import defaultReducer from "./defaultReducer";

export default defaultReducer('SUCCESS_ALERT', { message: "", visible: false})
